import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'

import { useStyles } from './PricingTable.styles'
import { pricingFields } from './pricing.data'

const PricingTable = ({ priceList, t }) => {
  const styles = useStyles()
  return (
    <Box className={styles.rowWrapper}>
      {pricingFields.map((field) => {
        if (!priceList || !priceList[field]) return ''
        return (
          <Grid container key={`pricing-row-${field}`}>
            <Grid item xs={6} className={styles.priceListItemContainer}>
              <Typography variant=" body2">
                {t(field.replaceAll('_', ' '))}
              </Typography>
            </Grid>
            <Grid item xs={6} className={styles.priceListItemContainer}>
              <Typography variant="body2">{priceList[field]}</Typography>
            </Grid>
          </Grid>
        )
      })}
    </Box>
  )
}

export default PricingTable
